var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "super-menu", class: { disabled: !_vm.value.enabled } },
    [
      _c("div", { staticClass: "super-tabs" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            {
              staticClass: "super-tab",
              class: { selected: _vm.currentTab === "canned-messages" },
              on: {
                click: function ($event) {
                  return _vm.changeTab("canned-messages")
                },
              },
            },
            [
              _c("ReadyContentsSvg"),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.cannedMessages")) +
                  "\n            "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isWaba()
            ? _c(
                "div",
                {
                  staticClass: "super-tab",
                  class: { selected: _vm.currentTab === "template-messages" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTab("template-messages")
                    },
                  },
                },
                [
                  _c("ReadyContentsSvg"),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.templateMessages")) +
                      "\n            "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "super-tab chatbot",
              class: { selected: _vm.currentTab === "chatbots" },
              on: {
                click: function ($event) {
                  return _vm.changeTab("chatbots")
                },
              },
            },
            [
              _c("ChatbotIcon"),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.chatbots")) +
                  "\n            "
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "SupsisButton",
              { attrs: { icon: "" }, on: { click: _vm.close } },
              [_c("div", { staticClass: "material-icons" }, [_vm._v("close")])]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "super-menu-content" },
        [
          _vm.currentTab === "canned-messages"
            ? _c("CannedMessageSelector", {
                attrs: {
                  "default-search": _vm.value.text,
                  type: _vm.value.type,
                  contact: _vm.contact,
                },
                on: { selected: _vm.selected },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === "template-messages"
            ? _c("TemplateMessages", {
                attrs: {
                  "default-search": _vm.value.text,
                  type: _vm.value.type,
                  contact: _vm.contact,
                },
                on: { send: _vm.sendTemplate },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === "chatbots"
            ? _c("ChatbotSelector", {
                attrs: {
                  "default-search": _vm.value.text,
                  type: _vm.value.type,
                  contact: _vm.contact,
                },
                on: { send: _vm.chatbotSelected },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }